/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response after updating a line item's match group
 * @export
 * @interface UpdateLineItemMatchGroup200Response
 */
export interface UpdateLineItemMatchGroup200Response {
    /**
     * Whether the operation was successful
     * @type {boolean}
     * @memberof UpdateLineItemMatchGroup200Response
     */
    success: boolean;
}

/**
 * Check if a given object implements the UpdateLineItemMatchGroup200Response interface.
 */
export function instanceOfUpdateLineItemMatchGroup200Response(value: object): value is UpdateLineItemMatchGroup200Response {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function UpdateLineItemMatchGroup200ResponseFromJSON(json: any): UpdateLineItemMatchGroup200Response {
    return UpdateLineItemMatchGroup200ResponseFromJSONTyped(json, false);
}

export function UpdateLineItemMatchGroup200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLineItemMatchGroup200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function UpdateLineItemMatchGroup200ResponseToJSON(json: any): UpdateLineItemMatchGroup200Response {
    return UpdateLineItemMatchGroup200ResponseToJSONTyped(json, false);
}

export function UpdateLineItemMatchGroup200ResponseToJSONTyped(value?: UpdateLineItemMatchGroup200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

